import { render, staticRenderFns } from "./ViewArticleContainer.vue?vue&type=template&id=c95c4fba&scoped=true&"
import script from "./ViewArticleContainer.vue?vue&type=script&lang=js&"
export * from "./ViewArticleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95c4fba",
  null
  
)

export default component.exports